import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { blue, green, orange, purple, red } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

const alertTokens = [
  { propertyPath: 'error.background', tokenName: '--data-informative-negative-low-contrast' },
  { propertyPath: 'error.text', tokenName: '--data-informative-negative-high-contrast' },
  { propertyPath: 'info.background', tokenName: '--data-informative-informative-low-contrast' },
  { propertyPath: 'info.text', tokenName: '--data-informative-informative-high-contrast' },
  { propertyPath: 'new.background', tokenName: '--data-informative-new-low-contrast' },
  { propertyPath: 'new.text', tokenName: '--data-informative-new-high-contrast' },
  { propertyPath: 'success.background', tokenName: '--data-informative-positive-low-contrast' },
  { propertyPath: 'success.text', tokenName: '--data-informative-positive-high-contrast' },
  { propertyPath: 'warning.background', tokenName: '--data-informative-intermediate-low-contrast' },
  { propertyPath: 'warning.text', tokenName: '--data-informative-intermediate-high-contrast' },
] satisfies Token[];

export const alertTokenMetadata: PaletteTokenMetadata = {
  componentName: 'alert',
  tokens: alertTokens,
};

export const alert = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['alert'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(alertTokens, tokens, xcorTokens);
  }

  return mode === 'light'
    ? {
        error: { background: red[100], text: red[700] },
        info: { background: blue[100], text: blue[700] },
        new: { background: purple[100], text: purple[700] },
        success: { background: green[100], text: green[700] },
        warning: { background: orange[100], text: orange[700] },
      }
    : {
        error: { background: red[800], text: red[100] },
        info: { background: blue[800], text: blue[100] },
        new: { background: purple[800], text: purple[100] },
        success: { background: green[800], text: green[100] },
        warning: { background: orange[800], text: orange[100] },
      };
};
